// src/firebase.js
import { getAuth } from "firebase/auth";
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";


const firebaseConfig = {
  apiKey: "AIzaSyDG9FaL-fxqQo1WVi-1SEgAZx7p-hbzp5c",
  authDomain: "plant-finder-5bb0a.firebaseapp.com",
  projectId: "plant-finder-5bb0a",
  storageBucket: "plant-finder-5bb0a.firebasestorage.app",
  messagingSenderId: "1007418249730",
  appId: "1:1007418249730:web:f37e71b4e4e4b54ae40d1b",
  measurementId: "G-RG2HQKD6D1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export { auth, db };